export const URI_BOUTIQUES = 'boutiques';
export const URI_BOUTIQUE = 'boutique';
export const URI_BOUTIQUE_BASE = `${URI_BOUTIQUE}/:boutiqueId`;
export const URI_BOUTIQUE_CLIENTS = 'clients';
